module.exports = __webpack_public_path__ + "site-build/img/curve.b75aa372.svg";